import React from "react";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

import { Pill, Tone } from "../../../styles";
import {
  AttentionContext,
  AttentionRowItem,
  AttentionTitle,
  SeverityIcon,
  TitleLine,
} from "../../styles";
import { AttentionSeverity } from "../../types";
import { AttentionActionLink } from "./AttentionActionLink";
import { AttentionRowProps } from "./types";

const SEVERITY_DISPLAY: Record<
  AttentionSeverity,
  { label: string; tone: Tone; Icon: typeof ErrorOutlineRoundedIcon }
> = {
  critical: {
    label: "Critical",
    tone: "critical",
    Icon: ErrorOutlineRoundedIcon,
  },
  warning: {
    label: "Warning",
    tone: "warning",
    Icon: WarningAmberRoundedIcon,
  },
  review: {
    label: "To review",
    tone: "unknown",
    Icon: AssignmentOutlinedIcon,
  },
};

export const AttentionRow: React.FC<AttentionRowProps> = ({
  item: { severity, title, context, action },
}) => {
  const { label, tone, Icon } = SEVERITY_DISPLAY[severity];

  return (
    <AttentionRowItem>
      <SeverityIcon $tone={tone} aria-hidden="true">
        <Icon fontSize="small" />
      </SeverityIcon>
      <TitleLine>
        <AttentionTitle>{title}</AttentionTitle>
        <Pill $tone={tone}>{label}</Pill>
      </TitleLine>
      <AttentionContext>
        {context.map((line) => (
          <span key={line}>{line}</span>
        ))}
      </AttentionContext>
      {action && <AttentionActionLink action={action} />}
    </AttentionRowItem>
  );
};
